module.exports = __webpack_public_path__ + "img/manblock-imagemobile.0b27fd05.png";